export default __webpack_public_path__ + "static/media/BatchCheck2.558cf685.svg";